import { Sparkles } from "lucide-react";
import type { SelectedSkill } from "../../api/types.js";

export function messageSelectedSkill(meta: unknown): SelectedSkill | null {
  const value = meta && typeof meta === "object" ? (meta as Record<string, unknown>).selectedSkill : null;
  if (!value || typeof value !== "object") return null;
  const skill = value as Record<string, unknown>;
  if (![skill.name, skill.displayName, skill.packSlug, skill.packDisplayName].every((item) => typeof item === "string" && item)) return null;
  return skill as SelectedSkill;
}

export function MessageSkillLabel({ skill }: { skill: SelectedSkill }) {
  return (
    <div className="message-skill-label" aria-label={`使用技能：${skill.displayName}`}>
      <Sparkles size={13} aria-hidden="true" />
      <span>{skill.displayName}</span>
    </div>
  );
}
